import { render } from "./youtube.svg?vue&type=template&id=f6ac0eca"
const script = {}
script.render = render

export default script